import { axiosAjax } from '@app/src/config/axios';
import { JobModel } from '@app/src/views/StepOne/form/models/job';

export const jobTopService = {
  async get(): Promise<JobModel[]> {
    try {
      const { data } = await axiosAjax.get(process.env.API_JOB_TOP);
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  }
}